import React from "react";
import AppRoutes from "./AppRoutes";
import "./App.css";
import { ServiceClientProvider } from "./services/ServiceClientContext";
import { AuthenticationProvider } from "./contexts/AuthenticationContext";
import CssBaseline from '@mui/material/CssBaseline';
import { LanguageSelectionProvider } from "./contexts/LanguageSelectionContext";

// Redux
//import { Provider } from 'react-redux';
//import store from './app/store';

// Fontsource can be configured to load specific subsets, weights and styles.
// Material UI's default typography configuration relies only on the 300, 400, 500, and 700 font weights.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const App: React.FC = () => {
  return (
    <ServiceClientProvider>
      <AuthenticationProvider>
        <LanguageSelectionProvider>
          <CssBaseline /> 
          <AppRoutes />
        </LanguageSelectionProvider>
      </AuthenticationProvider>
    </ServiceClientProvider>
  );
};

export default App;
